import { connect } from 'react-redux';
import AddProduct from './addProduct';

const mapStateToProps = ({ detailsPage }) => ({ detailsPage });

export default connect(mapStateToProps)(AddProduct);
